import * as React from 'react';
import * as styled from './styled';
import validateResponse from 'helpers/validate-response';
import isError from 'helpers/isError';
import {ExerciseProps} from './types';
import {ExerciseObject} from '../../../../api/exercise/types';
import {getExercise} from '../../../../api/exercise/requests';
import {getImageByPreview} from '../../../../api/library';

/**
 * The ingredient component.
 * @param {ExerciseProps} props
 * @return {React.ReactElement<ExerciseProps>}
 * @constructor
 */
function Exercise(
    props: ExerciseProps,
): React.ReactElement<ExerciseProps> {
  const [
    exercise, setExercise,
  ] = React.useState<ExerciseObject | undefined>(
    undefined,
  );

  React.useEffect(() => {
    fetchExercises(props.id);
  }, [props.index]);

  /**
   * Fetch the ingredient.
   * @param {IngredientObject["id"]} id
   */
  function fetchExercises(id: ExerciseObject['id']): void {
    getExercise(id).then((response) => {
      validateResponse(response);

      if (response && !isError(response)) {
        setExercise(response);
      }
    });
  }

  return exercise ? (
    <styled.Wrapper>
      <styled.Preview src={getImageByPreview(exercise.preview)} />
      <styled.Title>
        {exercise.title}
      </styled.Title>
      <styled.Box>
        5 подходов
      </styled.Box>
      <styled.Text>
        по
      </styled.Text>
      <styled.Box>
        20 раз
      </styled.Box>
      <styled.Text>
        Отдых между подходами
      </styled.Text>
      <styled.Box>
        1 минута
      </styled.Box>
    </styled.Wrapper>
  ) : <span>Loading...</span>;
}

export default React.memo(Exercise);
